import React from "react";
import { useEffect, useState } from "react";
import { faFilter, faTrash, faX, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnalyticsSearchOptions } from "../../pages/Analytics/analytics";
import { useToaster } from "../../components/hooks/useToaster";
import { useAppDispatch, useAppSelector } from "../../reducers/store";
import { 
  getAllAnalyticChartData, 
  deleteChartData, 
  selectChartData,
  selectIsLoading,
  selectError 
} from "../../reducers/analyticsSlice";

export interface ExtendedAnalyticsSearchOptions extends AnalyticsSearchOptions {
  name: string;
  description: string;
  id: number;
}

export interface Props {
  setSearchOptions: (searchOptions: AnalyticsSearchOptions) => void;
}

export default function FilterModalDropdown(props: Props) {
  const dispatch = useAppDispatch();
  const chartData = useAppSelector(selectChartData);
  const isLoading = useAppSelector(selectIsLoading);
  const error = useAppSelector(selectError);

  const [toasterState, openToaster, closeToaster] = useToaster();
  const [refreshCount, setRefreshCount] = useState(0);

  const [selectedItem, setSelectedItem] =
    useState<ExtendedAnalyticsSearchOptions | null>(null);

  useEffect(() => {
    const GetAllData = async () => {
      setTimeout(async () => {
        await dispatch(getAllAnalyticChartData());
      }, 100);
    };

    GetAllData();
  }, [refreshCount]);

  function loadSelectedItem() {
    if (selectedItem) {
      const selectedItemToLoad = {
        type: selectedItem.type,
        group: selectedItem.group,
        calculation: selectedItem.calculation,
        timeIncrement: selectedItem.timeIncrement,
        chartType: selectedItem.chartType,
        timePeriod: selectedItem.timePeriod,
        customStartDate: selectedItem.customStartDate,
        customEndDate: selectedItem.customEndDate,
      };

      props.setSearchOptions(selectedItemToLoad);
    }

    const modal = document.getElementById("my_modal_2") as HTMLDialogElement;
    if (modal) {
      modal.close();
    }
  }

  async function DeleteSelectedChart(chart: ExtendedAnalyticsSearchOptions) {
    if (chart.id) {
      await dispatch(deleteChartData({
        ...chart,
        userId: null,
        deleted: 1
      }));

      setRefreshCount(refreshCount + 1);
      openToaster(`Your filter "${chart.name}" has successfully been deleted. `, "medium", "success");
    } else {
      openToaster("Please select a filter to delete", "medium", "error");
    }
  }

  return (
    <div>
      {/* Open the modal using document.getElementById('ID').showModal() method */}
      <button
        className="flex h-[36px] w-[140px] items-center justify-evenly gap-x-[8px] rounded-md border border-gray-300 bg-white px-[10px] shadow-lg"
        style={{
          border: "1px solid transparent", // Transparent border to help with the visual effect
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)", // Blurred border effect
          backdropFilter: "blur(1px)", // Slightly reduced blur effect
          backgroundColor: "rgba(255, 255, 255, 0.1)", // Semi-transparent background
        }}
        onClick={() => {
            setRefreshCount(refreshCount + 1);
            (
              document.getElementById("my_modal_2") as HTMLDialogElement
            )?.showModal()
          }
        }
      >
        {" "}
        <FontAwesomeIcon
          className="text-[14px] text-[#212322]"
          icon={faFilter}
        />
        <span className="text-[14px]">Saved Filters</span>
      </button>
      <dialog id="my_modal_2" className="modal">
        <div className="modal-box overflow-auto rounded-md bg-white">
          <form method="dialog">
            <button className="text-tqsBlack absolute top-[1.5rem] right-[1.5rem]">
              <FontAwesomeIcon
                className="text-[20px] text-[#212322]"
                icon={faXmark}
              />
            </button>
          </form>
          <h3 className="mb-3 text-xl font-bold">Your Filters</h3>
          <p className="mb-3 text-[12px]">
            Click filter name to view descriptions
          </p>
          <div
            className="max-h-[400px] w-full overflow-auto"
            style={{ maxWidth: "600px" }}
          >
            {chartData?.length > 0 ? (
              chartData.map((item, index) => {
                const isSelected = selectedItem === item;
                return (
                  <div
                    key={index}
                    className={`mt-2 w-full ${
                      isSelected
                        ? "rounded-lg border-l-6 border-tqsYellow bg-yellow-100"
                        : "border-l-transparent"
                    } transition-all duration-300 ease-in-out`}
                  >
                    <button
                      onClick={() =>
                        setSelectedItem(selectedItem === item ? null : item)
                      }
                      className="flex w-full items-center justify-between p-4 text-left font-medium focus:outline-none"
                    >
                      <span className="font-bold">{item.name}</span>
                      <div className="flex gap-[10px]">
                        {selectedItem === item && (
                          <svg
                            className="h-6 w-6 text-tqsBlack"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        )}
                        {selectedItem != item && (
                          <button onClick={() => DeleteSelectedChart(item)}>
                            <FontAwesomeIcon
                              className="text-[14px] text-tqsRed"
                              icon={faTrash}
                            />
                          </button>
                        )}
                      </div>
                    </button>
                    {selectedItem === item && (
                      <div className="flex flex-col p-1">
                        {/* <div className="mb-2 ml-2 w-[95px] rounded-md bg-gray-300">
                          <p className="ml-2 text-[14px]">Description:</p>
                        </div> */}
                        <p className="ml-4 pb-2 text-[12px]">
                          {item.description}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div></div>
            )}
          </div>
          <div className="sticky bottom-0 left-0 right-0 mt-10 flex justify-end gap-2 bg-white p-4">
            {/* <form method="dialog">
              <button className="border-md btn border-none border-gray-300 bg-gray-300 text-tqsBlack hover:border-none hover:bg-gray-300">
                Cancel
              </button>
            </form> */}
            {selectedItem && 
              <button
              className="btn border-none bg-tqsRed text-tqsBlack hover:bg-tqsRed"
              onClick={() => DeleteSelectedChart(selectedItem)}
              >
                Delete
              </button>
            }

            <button
              className="btn border-none bg-tqsYellow text-tqsBlack hover:bg-tqsYellow"
              onClick={loadSelectedItem}
            >
              Select
            </button>
          </div>
        </div>
      </dialog>
    </div>
  );
}
